<template>
  <div class="font-16 px-13 py-9 pb-0">
    <p>
      Defined as items of precious metal or precious stones, jewellery, watches,
      works of art, computer equipment, portable electrical equipment other than
      televisions or radios.
    </p>

    <p>
      If £75,000 of Contents cover has been selected, the maximum limit for
      valuable items is £22,500.
    </p>

    <p>
      If £100,000 has been selected, the maximum limit for valuable items is
      £30,000.
    </p>

    <p>Valuables worth more than £2,500 need to be specified.</p>

    <p>
      Valuable items specified in the Personal Possessions section do not need
      to be specified here.
    </p>

    <div class="d-flex justify-center">
      <BaseButton
        depressed
        text="OK"
        rounded
        width="100%"
        max-width="420"
        height="60"
        dense
        :color="'psorange'"
        class="font-weight-bold font-20"
        @click="
          $emit('cancelWhatsIncluded', 'showWhatsIncludedValuablesInHome')
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogContentWhatsIncludedValuablesInHome",
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
};
</script>

<style lang="scss" scoped></style>
